var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.daysData.days),function(day,j){return _c('b-row',{key:j,staticClass:"mb-1"},[_c('b-col',{attrs:{"cols":"12"}},[_c('day',{attrs:{"day":day,"scene":_vm.scene}})],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }